/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { injectIntl } from "react-intl";
import * as taskOrderCrud from '../../../../crud/taskOrder.crud';
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import DataSource from 'devextreme/data/data_source';
import Spinner from '../../../../partials/layout/Spinner';
import Common from '../../../../shared/common';

class AssessmentCustomForm extends React.Component {
    constructor(props) {
        super(props);

        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;
        this.createDefaultFields = ((props.location || {}).state || {});

        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        this.createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        this.state = {
            isDxFormValid: true,
            taskOrderOptions: null,
            projectOrderOptions: null,
            isLoading: true,
            showSecondaryPriceSection: (this.props.contract.ispackaged || !!this.props.item?.effectcontractprice),
            showSecondaryDateSection: !!this.props.item?.effectcontractcompletion
        };
    }

    componentDidMount() {
        const { fields } = this.props.workflowItem;

        if (fields.TaskOrder.visible) {
            this.fetchTaskOrders();
        }
        if (fields.ProjectOrder.visible) {
            this.fetchProjectOrders();
        }
    }

    fetchTaskOrders = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await taskOrderCrud.getTaskOrdersToSelectList(contractid);
            //COVERTED TO DATASOURCE WITH FD-11007 DUE TO PERFORMENCE ISSUES AFTER 3K ITEMS
            const taskOrderOptions = new DataSource({
                store: {
                    type: 'array',
                    data: responseObj,
                    key: 'value'
                }
            });
            this.setState({ taskOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);
            const projectOrderOptions = responseObj.map(TO => {
                let displayValue = "";
                if (ispackaged) {
                    if (TO.linkedprojectcode) {
                        displayValue += `[${TO.linkedprojectcode}] - `;
                    }
                    if (TO.linkedprojectname) {
                        displayValue += `${TO.linkedprojectname} - `;
                    }
                    if (TO.projectordernumber) {
                        displayValue += `${TO.projectordernumber} - `;
                    }
                    if (TO.purchaseordervalue) {
                        displayValue += `${Common.FormatCurrencyNum(TO.purchaseordervalue, (this.props.contract || {}).currency)} - `;
                    }
                }
                displayValue += `${TO.referenceid} - ${TO.subject}`;
                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });
            this.setState({ projectOrderOptions: projectOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        this.state.isDxFormValid = isDxFormValid;

        if (field) {
            if (field === "effectcontractprice") {
                this.setState({ showSecondaryPriceSection: (this.props.contract.ispackaged || value) })
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
            else if (field === "effectcontractcompletion") {
                this.setState({ showSecondaryDateSection: value })
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
            else if (field === 'taskorderid') {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (field === 'taskorderid') {
                        if (value) {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                            if (additionalData) {
                                this.props.valueChangeHandler('taskorderreference', additionalData.referenceid, isDxFormValid, additionalData);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                            this.props.valueChangeHandler('taskorderreference', "", isDxFormValid, additionalData);
                        }
                    }
                }
            } else if (field === 'projectorderid') {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (field === 'projectorderid') {
                        if (value) {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                            if (additionalData) {
                                this.props.valueChangeHandler('projectorderreference', additionalData.referenceid, isDxFormValid, additionalData);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                            this.props.valueChangeHandler('projectorderreference', "", isDxFormValid, additionalData);
                        }
                    }
                }
            } else {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
        }
    }

    render() {
        const { fields } = this.props.workflowItem;

        if ((fields.TaskOrder.visible && !this.state.taskOrderOptions) ||
            (fields.ProjectOrder.visible && !this.state.projectOrderOptions)) {
            return (<Spinner />);
        }

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Subject.label, dataField: 'subject', editorOptions: { defaultValue: this.createDefaultSubject } },

            ]
        };
        if (fields.Type?.visible) {
            createFormConfig.fields.push(
                { label: fields.Type.label, dataField: 'type', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.createDefaultClause } },
            )
        }
        if (fields.Description?.visible) {
            createFormConfig.fields.push(
                { label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' },
            )

            if (fields.TaskOrder.visible) {
                //AUTO-SELECT TASK ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
                let defaultTaskOrderSelection = null;
                if (this.createDefaultFields?.itemBaseProps?.reftype === 'TaskOrder') {
                    defaultTaskOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
                }

                //createFormConfig.fields.push({ label: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER' }, { TASK_ORDER: this.props.taskOrderNotificationName }), dataField: 'taskorderid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.state.taskOrderOptions, valueExpr: 'taskorderid', displayExpr: 'display', defaultValue: defaultTaskOrderSelection } });
                createFormConfig.fields.push({ label: fields.TaskOrder.label, dataField: 'taskorderid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.state.taskOrderOptions, valueExpr: 'taskorderid', displayExpr: 'display', defaultValue: defaultTaskOrderSelection } });
            }

            if (fields.ProjectOrder.visible) {
                //AUTO-SELECT PROJECT ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
                let defaultProjectOrderSelection = null;
                if (this.createDefaultFields?.itemBaseProps?.reftype === 'ProjectOrder') {
                    defaultProjectOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
                }

                createFormConfig.fields.push({ label: fields.ProjectOrder.label, dataField: 'projectorderid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.state.projectOrderOptions, valueExpr: 'value', displayExpr: 'display', defaultValue: defaultProjectOrderSelection } });
            }

            if (fields.Amount.visible && fields.EffectContractPrice) {
                createFormConfig.fields.push({
                    label: fields.EffectContractPrice.label,
                    dataField: 'effectcontractprice',
                    editorType: 'dxCheckBox',
                    editorOptions: { readOnly: !fields.EffectContractPrice.visible },
                    dependOn: 'type',
                    dependOnValue: (item, selectedItem) => {
                        if (!fields.EffectContractPrice.visible) {
                            //Always use the effect
                            return ["EFFECT_PRICE", "EFFECT_COMPLETION_PRICE"].includes(selectedItem.effect);
                        }
                        else if (selectedItem && selectedItem.effect && (item.effectcontractprice === null || item.effectcontractprice === undefined)) {
                            //ONLY ASSIGN DEFAULTS IF NOT ASSIGNED BEFORE
                            return ["EFFECT_PRICE", "EFFECT_COMPLETION_PRICE"].includes(selectedItem.effect);
                        } else {
                            //return whats ASSIGNED BEFORE
                            return item.effectcontractprice;
                        }
                    }
                },
                    { label: fields.Amount.label, dataField: 'amount', editorType: 'dxNumberBox' },
                )
            }
            if (fields.Days.visible && fields.EffectContractCompletion) {
                createFormConfig.fields.push(
                    {
                        label: fields.EffectContractCompletion.label,
                        dataField: 'effectcontractcompletion',
                        editorType: 'dxCheckBox',
                        editorOptions: { readOnly: !fields.EffectContractCompletion.visible },
                        dependOn: 'type',
                        dependOnValue: (item, selectedItem) => {
                            if (!fields.EffectContractCompletion.visible) {
                                //Always use the effect
                                return ["EFFECT_COMPLETION", "EFFECT_COMPLETION_PRICE"].includes(selectedItem.effect);
                            }
                            else if (selectedItem && selectedItem.effect && (item.effectcontractcompletion === null || item.effectcontractcompletion === undefined)) {
                                //ONLY ASSIGN DEFAULTS IF NOT ASSIGNED BEFORE
                                return ["EFFECT_COMPLETION", "EFFECT_COMPLETION_PRICE"].includes(selectedItem.effect);
                            } else {
                                //return whats ASSIGNED BEFORE
                                return item.effectcontractcompletion;
                            }
                        }
                    },
                    { label: fields.Days.label, dataField: 'days', editorType: 'dxNumberBox', editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }, validation: { type: 'range', min: -36525, max: 36525, warning: this.props.intl.formatMessage({ id: 'ASSESSMENT.FORM.INVALID_DATE' }, { VALUE: 36525 }) } }
                )
            }

            return (
                <div>
                    <BiDynamicForm
                        validatorRef={this.validatorRef}
                        item={this.props.item}
                        config={createFormConfig}
                        onSubmitHandler={this.props.onSubmitHandler}
                        //valueChangeHandler={this.props.valueChangeHandler}
                        valueChangeHandler={this.fieldChanged}
                        customFields={this.props.customFields}
                        assetFieldsEnabled={this.props.assetFieldsEnabled}
                        assetid={this.createDefaultAsset}
                        secondaryPriceSectionEnabled={this.state.showSecondaryPriceSection}
                        secondaryDateSectionEnabled={this.state.showSecondaryDateSection}
                        taskorderid={this.props.item?.taskorderid}
                        projectorderid={this.props.item?.projectorderid}
                    />
                </div>
            );
        }
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // contractTemplate: store.contract.template,
    // globalResources: store.contract.template.resources
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(AssessmentCustomForm)));